import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/altman-z-score',
  component: () => import('../../routes/AltmanZScore.svelte'),
  card: {
    id: 'altman-z-score',
    title: 'Altman Z-Score Calculator',
    description: 'Predicts the likelihood of a company going bankrupt using five financial ratios from the Altman Z-Score model.',
    icon: 'analytics',
    iconBgClass: 'bg-violet-50',
    iconTextClass: 'text-violet-600',
    href: '/altman-z-score',
    category: 'Business',
  },
  seo: {
    title: 'Altman Z-Score Calculator – Bankruptcy Prediction Model',
    description: 'Free Altman Z-Score calculator predicts corporate bankruptcy risk using five financial ratios. Enter working capital, retained earnings, EBIT, equity value, and sales to calculate Z-Score and zone classification.',
  },
};

export default meta;
